// src/hooks/useLogoSrc.ts
import { useMemo } from "react";
import { useSettings } from "../context/SettingsContext";

export const useLogoSrc = () => {
  const { settings } = useSettings();

  const logoSrc = useMemo(() => {
    const logoPath = settings.logoPath;
    const isValid = logoPath && !logoPath.includes("null") && logoPath.trim() !== "";
    return isValid ? `${logoPath}?v=${Date.now()}` : "";
  }, [settings.logoPath]);

  const displayName = useMemo(() => {
    const name = settings.logoName;
    return name && name.trim() !== "" ? name : "";
  }, [settings.logoName]);

  return {
    logoSrc,
    displayName,
  };
};
